"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Example OEM',
  color: {
    primary: {
      v100: '#F5978E',
      v200: '#F06356',
      v300: '#D42313',
      v400: '#B71E10',
      v500: '#71120A',
      v600: '#420B06',
      v700: '#170402'
    },
    secondary: {
      v100: '#98EBF6',
      v200: '#69E2F2',
      v300: '#13BDD4'
    },
    neutral: {
      v000: '#000000',
      v100: '#ffffff',
      v200: '#F4F8FA',
      v300: '#D9DDE9',
      v400: '#AAB1C7',
      v500: '#757989'
    },
    validation: {
      warning: '#feb948',
      success: '#1dd08b',
      error: '#ff7171'
    }
  }
};